enum CarouselDirection {
  LEFT,
  RIGHT,
  UP,
  DOWN,
}

enum CarouselOrientation {
  HORIZONTAL,
  VERTICAL,
}

enum CarouselTransition {
  SLIDE,
  FADE,
}

interface SlidesPerPageInterface {
  sm?: { slidesPerPage?: number; size?: number };
  md?: { slidesPerPage?: number; size?: number };
  lg?: { slidesPerPage?: number; size?: number };
  xl?: { slidesPerPage?: number; size?: number };
}

export { CarouselDirection, CarouselOrientation, CarouselTransition, SlidesPerPageInterface };
